module.exports = __webpack_public_path__ + "static/media/mac_pro.1e091a6c.jpg";